function g(e){return e==="client"?"ck":"sk"}export{g as a};
